export default __webpack_public_path__ + "static/media/large-highest.11da84d2.svg";